import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { MEGDataService } from "./meg-data.service";
import { MegConfig } from "../../models/dmv/models";
import { MegConfigResponse } from "src/app/models/dmv/meg-config-response";
import { DMVStoreService } from "./../dmv/dmv-store.service";

import { AppUtil } from "./../../utils/app.util";

@Injectable({ providedIn: "root" })
export class MEGStoreService {
	constructor(
		private megDataService: MEGDataService,
		private dmvStoreService: DMVStoreService
	) {}

	private readonly _configuration = new BehaviorSubject<MegConfigResponse>(
		null
	);

	// Expose the observable$ (read only stream)
	readonly configurations$ = this._configuration.asObservable();

	// The getter will return the last value emitted
	get configuration(): MegConfigResponse {
		return this._configuration.getValue();
	}

	// Assigning a value will push it onto the observable
	set configuration(val: MegConfigResponse) {
		this._configuration.next(val);
	}

	// Data access by consumers
	public readonly configurationsData$ = this.configurations$;

	public getConfigurations(
		appType: number,
		entryPointID: number,
		token?: string
	) {
		this.megDataService
			.getConfigurationResponse(appType, entryPointID, token)
			.subscribe(
				megResponse => {
					if (megResponse) {
						this.configuration = megResponse;
						AppUtil.log("MEGStoreService megResponse =>", this.configuration);
					}
				},
				error => {
					error.status = 408;
					this.configuration = error;
				}
			);
	}
}
